export default "__VITE_ASSET__Ctz2l9FK__"